/**
 * ASM STORE — Vehicle Search System v3.0
 *
 * MEJORAS v3.0:
 *  ✅ Mejora 1 — Fallback inteligente: si busca con año y obtiene 0 resultados,
 *                reintenta automáticamente sin año y avisa al usuario
 *  ✅ Mejora 2 — Contador en tiempo real: muestra cuántos productos hay
 *                antes de hacer click en buscar
 *  ✅ Mejora 5 — Mensaje "sin resultados" con acciones útiles en página de resultados
 *  ✅ Mejora 6 — Vehículo guardado en localStorage (persiste entre sesiones)
 *                con botón para limpiar
 */

(function () {
  'use strict';

  /* ════════════════════════════════════════════════════════════
     DATOS DE VEHÍCULOS
     ════════════════════════════════════════════════════════════ */
  const VEHICLES = {
    'Jeep': {
      'Grand Cherokee': [1993, 2023],
      'Cherokee':       [1987, 2023],
      'Cherokee KL':    [2014, 2023],
      'Cherokee Liberty':[2002,2013],
      'Wrangler':       [1987, 2023],
      'Compass':        [2007, 2023],
      'Renegade':       [2015, 2023],
      'Patriot':        [2007, 2017],
      'Commander':      [2006, 2010],
      'Gladiator':      [2019, 2023],
    },
    'Ford': {
      'F-150':       [1975, 2023],
      'F-350':       [1975, 2010],
      'Explorer':    [1991, 2023],
      'Escape':      [2001, 2022],
      'Ranger':      [1995, 2022],
      'Fiesta':      [1996, 2019],
      'EcoSport':    [2004, 2021],
      'Edge':        [2007, 2022],
      'Fusion':      [2006, 2020],
      'Focus':       [2012, 2019],
      'Expedition':  [1997, 2015],
      'Bronco':      [1985, 1996],
    },
    'Dodge': {
      'Journey':  [2009, 2020],
      'Durango':  [2011, 2023],
      'Neon':     [1995, 2005],
      'Caravan':  [1990, 2010],
    },
    'Ram': {
      'Ram':      [2009, 2023],
      'Ram 1500': [2009, 2023],
      'Ram 2500': [2009, 2023],
    },
    'Chrysler': {
      'Town & Country': [1990, 2016],
      'Pacifica':       [2005, 2008],
    },
    'Chevrolet': {
      'Cruze':       [2011, 2019],
      'Sonic':       [2012, 2019],
      'Tracker':     [2013, 2023],
      'Captiva':     [2006, 2017],
      'HHR':         [2006, 2011],
      'TrailBlazer': [2002, 2010],
      'Traverse':    [2009, 2019],
      'Tahoe':       [2007, 2016],
      'Cheyenne':    [1988, 2001],
      'Blazer':      [1991, 2001],
      'Aveo':        [2007, 2014],
      'Optra':       [2004, 2010],
      'Corsa':       [2002, 2008],
      'Spark':       [2010, 2023],
      'Silverado':   [2007, 2015],
      'Luv D-Max':   [2003, 2012],
    },
    'Toyota': {
      'Hilux':      [1990, 2023],
      'Hilux Vigo': [2005, 2015],
      'Prado':      [2000, 2023],
    },
    'Nissan': {
      'Versa':   [2007, 2023],
      'Sentra':  [2000, 2023],
      'Juke':    [2010, 2019],
      'X-Trail': [2005, 2015],
      'Tida':    [2006, 2012],
    },
    'Mazda': {
      'Mazda 3': [2004, 2012],
      'Mazda 6': [2004, 2012],
      'BT-50':   [2006, 2023],
    },
    'Fiat': {
      'Uno':   [1995, 2010],
      'Palio': [1997, 2010],
      'Siena': [1997, 2010],
    },
    'Suzuki': {
      'Grand Vitara': [2000, 2015],
      'Vitara':       [1995, 2005],
    },
    'Peugeot': {
      '306': [1993, 2002],
      '405': [1988, 1997],
      '205': [1983, 1998],
    },
    'SsangYong': {
      'Actyon':  [2005, 2014],
      'Rexton':  [2001, 2017],
    },
    'Renault': {
      'Clio':    [1990, 2023],
      'Symbol':  [2000, 2015],
      'Megane':  [1995, 2016],
    },
    'Volkswagen': {
      'Bora':    [1998, 2006],
      'Golf':    [1996, 2020],
      'Passat':  [1996, 2010],
    },
  };

  /* ════════════════════════════════════════════════════════════
     CATEGORÍAS DE PRODUCTOS
     handle = valor exacto del metacampo parts.subcategory en Shopify
              (debe coincidir con lo importado en el CSV)
     ════════════════════════════════════════════════════════════ */
  const CATEGORIES = {
    'Motor': [
      { label: 'Anillos',             handle: 'Anillos' },
      { label: 'Árboles de Levas',    handle: 'Árboles de Levas' },
      { label: 'Balancines',          handle: 'Balancines' },
      { label: 'Bomba Aceite',        handle: 'Bomba Aceite' },
      { label: 'Cigüeñales',          handle: 'Cigüeñales' },
      { label: 'Culatas',             handle: 'Culatas' },
      { label: 'Enfriadores Aceite',  handle: 'Enfriadores Aceite' },
      { label: 'Impulsadores',        handle: 'Impulsadores' },
      { label: 'Kits de Repartición', handle: 'Kits de Repartición' },
      { label: 'Pistones',            handle: 'Pistones' },
      { label: 'Polea Cigüeñal',      handle: 'Polea Cigüeñal' },
      { label: 'Soportes de Motor',   handle: 'Soportes de Motor' },
      { label: 'Solenoide VVT',       handle: 'Solenoide VVT' },
    ],
    'Sistema de Enfriamiento': [
      { label: 'Aspas / Ventaviolas',    handle: 'Aspas / Ventaviolas' },
      { label: 'Bomba Agua',             handle: 'Bomba Agua' },
      { label: 'Carcasas de Termostato', handle: 'Carcasas de Termostato' },
      { label: 'Depósitos',              handle: 'Depósitos' },
      { label: 'Enfocadores',            handle: 'Enfocadores' },
      { label: 'Fan Clutch',             handle: 'Fan Clutch' },
      { label: 'Motoventiladores',       handle: 'Motoventiladores' },
      { label: 'Radiadores',             handle: 'Radiadores' },
      { label: 'Sensor Temperatura',     handle: 'Sensor Temperatura' },
      { label: 'Tapas',                  handle: 'Tapas' },
    ],
    'Combustible y Aire': [
      { label: 'Bomba Gasolina',             handle: 'Bomba Gasolina' },
      { label: 'Cuerpos de Aceleración',     handle: 'Cuerpos de Aceleración' },
      { label: 'Válvula IAC',               handle: 'Válvula IAC' },
      { label: 'Sensor Presión Combustible', handle: 'Sensor Presión Combustible' },
    ],
    'Escape y Emisiones': [
      { label: 'Válvula EGR',    handle: 'Válvula EGR' },
      { label: 'Sensor MAF',     handle: 'Sensor MAF' },
      { label: 'Sensor MAP',     handle: 'Sensor MAP' },
      { label: 'Sensor Oxígeno', handle: 'Sensor Oxígeno' },
      { label: 'Válvula PCV',    handle: 'Válvula PCV' },
    ],
    'Encendido': [
      { label: 'Bobinas',    handle: 'Bobinas' },
      { label: 'Sensor CKP', handle: 'Sensor CKP' },
      { label: 'Sensor CMP', handle: 'Sensor CMP' },
    ],
    'Eléctrico': [
      { label: 'Actuador Compuerta',       handle: 'Actuador Compuerta' },
      { label: 'Sensor Presión Aceite',    handle: 'Sensor Presión Aceite' },
      { label: 'Sensor de Reversa',        handle: 'Sensor de Reversa' },
      { label: 'Sensor de Velocidad',      handle: 'Sensor de Velocidad' },
      { label: 'Sensor Velocímetro',       handle: 'Sensor Velocímetro' },
      { label: 'Switch de Ventana',        handle: 'Switch de Ventana' },
      { label: 'Switch Ignición',          handle: 'Switch Ignición' },
      { label: 'Switch Limpiaparabrisas',  handle: 'Switch Limpiaparabrisas' },
      { label: 'Switch Luces',             handle: 'Switch Luces' },
      { label: 'Sensor TPS',               handle: 'Sensor TPS' },
    ],
    'Freno y Maza de Rueda': [
      { label: 'Sensor ABS',  handle: 'Sensor ABS' },
      { label: 'Bocines',     handle: 'Bocines' },
      { label: 'Rodamientos', handle: 'Rodamientos' },
    ],
    'Suspensión': [
      { label: 'Soportes de Amortiguador', handle: 'Soportes de Amortiguador' },
    ],
    'Dirección': [
      { label: 'Bomba Hidráulico', handle: 'Bomba Hidráulico' },
      { label: 'Caja Dirección',   handle: 'Caja Dirección' },
      { label: 'Eje Dirección',    handle: 'Eje Dirección' },
      { label: 'Pera Hidráulica',  handle: 'Pera Hidráulica' },
    ],
    'Correa de Transmisión': [
      { label: 'Poleas',             handle: 'Poleas' },
      { label: 'Tensores de Correa', handle: 'Tensores de Correa' },
    ],
    'Tren de Transmisión': [
      { label: 'Eje Dirección', handle: 'Eje Dirección' },
    ],
    'Transmisión': [
      { label: 'Bomba Clutch', handle: 'Bomba Clutch' },
    ],
    'Calefacción y Aire Acondicionado': [
      { label: 'Condensadores', handle: 'Condensadores' },
    ],
  };

  /* ════════════════════════════════════════════════════════════
     ESTADO GLOBAL
     ════════════════════════════════════════════════════════════ */
  const STATE = {
    make:        null,
    model:       null,
    year:        null,
    engine:      null,
    category:    null,
    subcategory: null,   // handle de colección Shopify
    mode:        'vehicle',
    reference:   '',
  };

  // localStorage para persistencia entre sesiones (Mejora 6)
  const SK_LOCAL   = 'asm_vehicle_v3';
  const SK_SESSION = 'asm_vehicle_v3_session';

  function saveState() {
    try {
      const data = JSON.stringify(STATE);
      sessionStorage.setItem(SK_SESSION, data);
      // Solo guardar make/model en localStorage (no año — cambia frecuentemente)
      if (STATE.make) {
        localStorage.setItem(SK_LOCAL, JSON.stringify({
          make: STATE.make, model: STATE.model
        }));
      }
    } catch(_) {}
  }

  function loadState() {
    try {
      // Primero intenta sessión (más reciente)
      const session = sessionStorage.getItem(SK_SESSION);
      if (session) {
        Object.assign(STATE, JSON.parse(session));
        return;
      }
      // Si no hay sesión, cargar el vehículo guardado en localStorage
      const local = localStorage.getItem(SK_LOCAL);
      if (local) {
        const saved = JSON.parse(local);
        STATE.make  = saved.make  || null;
        STATE.model = saved.model || null;
      }
    } catch(_) {}
  }

  function clearSavedVehicle() {
    try {
      localStorage.removeItem(SK_LOCAL);
      sessionStorage.removeItem(SK_SESSION);
    } catch(_) {}
    STATE.make = STATE.model = STATE.year = STATE.engine = null;
  }

  /* ════════════════════════════════════════════════════════════
     UTILIDADES
     ════════════════════════════════════════════════════════════ */

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  function yearRange(start, end) {
    const years = [];
    for (let y = end; y >= start; y--) years.push(String(y));
    return years;
  }

  function shimmer(el) {
    const field = el.closest('.asm-field') || el;
    field.classList.add('asm-field--shimmer');
    setTimeout(() => field.classList.remove('asm-field--shimmer'), 800);
  }

  function fillSelect(sel, options, placeholder) {
    sel.innerHTML = `<option value="">${placeholder}</option>`;
    options.forEach(o => {
      const el = document.createElement('option');
      el.value = el.textContent = o;
      sel.appendChild(el);
    });
    sel.disabled = false;
    shimmer(sel);
  }

  function clearSelect(sel, placeholder) {
    sel.innerHTML = `<option value="">${placeholder}</option>`;
    sel.disabled = true;
    sel.value = '';
    sel.closest('.asm-field')?.classList.remove('asm-field--filled','asm-field--active');
  }

  /* ════════════════════════════════════════════════════════════
     CONSTRUCCIÓN DE URL (metafields)
     ════════════════════════════════════════════════════════════ */

  function getLocalePrefix() {
    const locale = (window.Shopify && window.Shopify.locale) || 'es';
    const code   = locale.toLowerCase();
    const path   = window.location.pathname;
    if (path.startsWith('/' + code + '/') || path === '/' + code) {
      return '/' + code;
    }
    return '';
  }

  function buildURL(make, model, year, engine) {
    const prefix = getLocalePrefix();
    const m  = make   ?? STATE.make;
    const mo = model  ?? STATE.model;
    const y  = year   ?? STATE.year;
    const e  = engine ?? STATE.engine;

    if (STATE.mode === 'reference' && STATE.reference.trim()) {
      return `${prefix}/search?q=${encodeURIComponent(STATE.reference.trim())}&type=product`;
    }

    // Se necesita al menos marca o subcategoría para buscar
    if (!m && !STATE.subcategory) return null;

    const p = new URLSearchParams();
    if (m)  p.append('filter.p.m.vehicle.brand', m);
    if (mo) p.append('filter.p.m.vehicle.model', mo);
    if (y) {
      p.append('filter.p.m.vehicle.year_from.lte', y);
      p.append('filter.p.m.vehicle.year_to.gte',   y);
    }
    if (e)                p.append('filter.p.m.vehicle.engine',       e);
    if (STATE.subcategory) p.append('filter.p.m.parts.subcategory', STATE.subcategory);

    return `${prefix}/collections/all?${p.toString()}`;
  }

  /* ════════════════════════════════════════════════════════════
     MEJORA 2 — CONTADOR EN TIEMPO REAL
     Obtiene el conteo de productos usando la Section Rendering API
     de Shopify (mismo dominio, sin CORS)
     ════════════════════════════════════════════════════════════ */

  let countDebounce = null;

  /* Caché de HTML de colección: el contador y el dropdown de cilindraje
     comparten la misma respuesta para no duplicar requests */
  const HTML_CACHE = new Map();

  function fetchCollectionHTML(url) {
    if (!HTML_CACHE.has(url)) {
      const p = fetch(`${url}&view=ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(r => (r.ok ? r.text() : null))
        .catch(() => null);
      HTML_CACHE.set(url, p);
      if (HTML_CACHE.size > 20) HTML_CACHE.delete(HTML_CACHE.keys().next().value);
    }
    return HTML_CACHE.get(url);
  }

  async function fetchProductCount(make, model, year, engine) {
    try {
      const url = buildURL(make, model, year, engine);
      if (!url) return null;

      const html = await fetchCollectionHTML(url);
      if (!html) return null;

      // mobile-facets__count muestra "X de Y productos" (o "X products"):
      // el PRIMER número es siempre el conteo filtrado, en cualquier idioma
      const facetCount = html.match(/mobile-facets__count[^>]*>\s*([\d.,]+)/);
      if (facetCount) {
        return parseInt(facetCount[1].replace(/[.,]/g, ''), 10);
      }
      // Fallback: primer "N productos/products" del HTML
      const match = html.match(/(\d[\d.,]*)\s*(?:producto|product)/i);
      if (match) {
        return parseInt(match[1].replace(/[.,]/g, ''), 10);
      }
      return null;
    } catch (_) {
      return null;
    }
  }

  /* Llena el dropdown de cilindraje con los valores del facet
     vehicle.engine que existen para la marca/modelo/año elegidos.
     Se pasa engine='' a buildURL para excluirlo del filtro
     (null caería en STATE.engine por el operador ??). */
  async function fillEngines(engineEl) {
    if (!engineEl || !STATE.make) return;
    try {
      const url = buildURL(STATE.make, STATE.model, STATE.year, '');
      if (!url || url.indexOf('/search?') > -1) return;

      const html = await fetchCollectionHTML(url);
      if (!html) return;

      const vals = [];
      // Solo cilindrajes con productos para la selección actual:
      // se descartan inputs disabled y valores cuyo conteo "(N)" sea 0
      // (el disabled de Shopify no considera los filtros de rango de año)
      const tagRe = /<input\b[^>]*name="filter\.p\.m\.vehicle\.engine"[^>]*>/g;
      let t;
      while ((t = tagRe.exec(html)) !== null) {
        if (/\bdisabled\b/.test(t[0])) continue;
        const m = t[0].match(/value="([^"]*)"/);
        if (!m || !m[1]) continue;
        const despues = html.slice(tagRe.lastIndex, tagRe.lastIndex + 400);
        const cnt = despues.match(/\((\d[\d.,]*)\)/);
        if (cnt && parseInt(cnt[1].replace(/[.,]/g, ''), 10) === 0) continue;
        vals.push(m[1]);
      }

      const unique = [...new Set(vals)].sort((a, b) => parseFloat(a) - parseFloat(b));
      const prev = engineEl.value || STATE.engine;

      if (!unique.length) {
        clearSelect(engineEl, getI18n().placeholderEngine);
        return;
      }
      fillSelect(engineEl, unique, getI18n().placeholderEngine);
      engineEl.disabled = false;
      if (prev && unique.indexOf(prev) > -1) {
        engineEl.value = prev;
        engineEl.closest('.asm-field')?.classList.add('asm-field--filled');
      }
    } catch (_) { /* el cilindraje es opcional: nunca romper la búsqueda */ }
  }

  const ASM_I18N = {
    es: {
      defaultNote: (n) => `Más de <strong>${n}</strong> referencias disponibles`,
      loading: 'Buscando repuestos...',
      zero: '⚠️ Sin repuestos con esos filtros — prueba con menos opciones',
      found: (n) => `<strong>${n}</strong> repuesto${n !== 1 ? 's' : ''} disponible${n !== 1 ? 's' : ''}`,
      foundFor: (n, v) => `<strong>${n}</strong> repuesto${n !== 1 ? 's' : ''} disponible${n !== 1 ? 's' : ''} para <strong>${v}</strong>`,
      placeholderMake: 'Marca', placeholderModel: 'Modelo', placeholderYear: 'Año', placeholderEngine: 'Cilindraje',
      optionCategory: 'Categoría (opcional)', optionPart: 'Parte (opcional)', selectPart: 'Selecciona la parte',
      savedVehicle: (v) => `Vehículo guardado: ${v}`,
      searchLabel: (p) => `Buscar: ${p}`, searchBtn: 'BUSCAR REPUESTO',
    },
    en: {
      defaultNote: (n) => `More than <strong>${n}</strong> references available`,
      loading: 'Searching parts...',
      zero: '⚠️ No parts found with those filters — try fewer options',
      found: (n) => `<strong>${n}</strong> part${n !== 1 ? 's' : ''} available`,
      foundFor: (n, v) => `<strong>${n}</strong> part${n !== 1 ? 's' : ''} available for <strong>${v}</strong>`,
      placeholderMake: 'Brand', placeholderModel: 'Model', placeholderYear: 'Year', placeholderEngine: 'Engine',
      optionCategory: 'Category (optional)', optionPart: 'Part (optional)', selectPart: 'Select a part',
      savedVehicle: (v) => `Saved vehicle: ${v}`,
      searchLabel: (p) => `Search: ${p}`, searchBtn: 'SEARCH PART',
    },
    fr: {
      defaultNote: (n) => `Plus de <strong>${n}</strong> références disponibles`,
      loading: 'Recherche de pièces...',
      zero: '⚠️ Aucune pièce avec ces filtres — essayez avec moins de critères',
      found: (n) => `<strong>${n}</strong> pièce${n !== 1 ? 's' : ''} disponible${n !== 1 ? 's' : ''}`,
      foundFor: (n, v) => `<strong>${n}</strong> pièce${n !== 1 ? 's' : ''} disponible${n !== 1 ? 's' : ''} pour <strong>${v}</strong>`,
      placeholderMake: 'Marque', placeholderModel: 'Modèle', placeholderYear: 'Année', placeholderEngine: 'Moteur',
      optionCategory: 'Catégorie (optionnel)', optionPart: 'Pièce (optionnel)', selectPart: 'Sélectionner une pièce',
      savedVehicle: (v) => `Véhicule enregistré: ${v}`,
      searchLabel: (p) => `Rechercher: ${p}`, searchBtn: 'CHERCHER PIÈCE',
    },
    'pt-BR': {
      defaultNote: (n) => `Mais de <strong>${n}</strong> referências disponíveis`,
      loading: 'Buscando peças...',
      zero: '⚠️ Nenhuma peça com esses filtros — tente com menos opções',
      found: (n) => `<strong>${n}</strong> peça${n !== 1 ? 's' : ''} disponível${n !== 1 ? 'is' : ''}`,
      foundFor: (n, v) => `<strong>${n}</strong> peça${n !== 1 ? 's' : ''} disponível${n !== 1 ? 'is' : ''} para <strong>${v}</strong>`,
      placeholderMake: 'Marca', placeholderModel: 'Modelo', placeholderYear: 'Ano', placeholderEngine: 'Motor',
      optionCategory: 'Categoria (opcional)', optionPart: 'Peça (opcional)', selectPart: 'Selecionar peça',
      savedVehicle: (v) => `Veículo salvo: ${v}`,
      searchLabel: (p) => `Buscar: ${p}`, searchBtn: 'BUSCAR PEÇA',
    },
  };

  const CATEGORY_LABELS = {
    'Motor':                             { en: 'Engine',                         fr: 'Moteur',                            'pt-BR': 'Motor' },
    'Sistema de Enfriamiento':           { en: 'Cooling System',                  fr: 'Système de refroidissement',        'pt-BR': 'Sistema de arrefecimento' },
    'Combustible y Aire':                { en: 'Fuel & Air',                      fr: 'Carburant & Air',                   'pt-BR': 'Combustível e Ar' },
    'Escape y Emisiones':                { en: 'Exhaust & Emissions',             fr: 'Échappement & Émissions',           'pt-BR': 'Escapamento e Emissões' },
    'Encendido':                         { en: 'Ignition',                        fr: 'Allumage',                          'pt-BR': 'Ignição' },
    'Eléctrico':                         { en: 'Electrical',                      fr: 'Électrique',                        'pt-BR': 'Elétrico' },
    'Freno y Maza de Rueda':             { en: 'Brake & Wheel Hub',               fr: 'Frein & Moyeu',                     'pt-BR': 'Freio e Cubo de Roda' },
    'Suspensión':                        { en: 'Suspension',                      fr: 'Suspension',                        'pt-BR': 'Suspensão' },
    'Dirección':                         { en: 'Steering',                        fr: 'Direction',                         'pt-BR': 'Direção' },
    'Correa de Transmisión':             { en: 'Drive Belt',                      fr: 'Courroie de transmission',           'pt-BR': 'Correia de Transmissão' },
    'Tren de Transmisión':               { en: 'Drivetrain',                      fr: 'Transmission',                      'pt-BR': 'Tração' },
    'Transmisión':                       { en: 'Transmission',                    fr: 'Boîte de vitesses',                 'pt-BR': 'Transmissão' },
    'Calefacción y Aire Acondicionado':  { en: 'HVAC',                            fr: 'Chauffage & Climatisation',          'pt-BR': 'Aquecimento e Ar Cond.' },
  };

  const SUB_LABELS = {
    'Anillos':                    { en: 'Piston Rings',           fr: 'Segments',                     'pt-BR': 'Anéis' },
    'Árboles de Levas':           { en: 'Camshafts',              fr: 'Arbres à cames',               'pt-BR': 'Árvores de Cames' },
    'Balancines':                 { en: 'Rocker Arms',            fr: 'Culbuteurs',                   'pt-BR': 'Balancins' },
    'Bomba Aceite':               { en: 'Oil Pump',               fr: 'Pompe à huile',                'pt-BR': 'Bomba de Óleo' },
    'Cigüeñales':                 { en: 'Crankshafts',            fr: 'Vilebrequins',                 'pt-BR': 'Virabrequins' },
    'Culatas':                    { en: 'Cylinder Heads',         fr: 'Culasses',                     'pt-BR': 'Cabeçotes' },
    'Enfriadores Aceite':         { en: 'Oil Coolers',            fr: "Refroidisseurs d'huile",       'pt-BR': 'Resfriadores de Óleo' },
    'Impulsadores':               { en: 'Lifters / Tappets',      fr: 'Poussoirs',                    'pt-BR': 'Tuchos' },
    'Kits de Repartición':        { en: 'Timing Kits',            fr: 'Kits de distribution',         'pt-BR': 'Kits de Distribuição' },
    'Pistones':                   { en: 'Pistons',                fr: 'Pistons',                      'pt-BR': 'Pistões' },
    'Polea Cigüeñal':             { en: 'Crankshaft Pulley',      fr: 'Poulie de vilebrequin',        'pt-BR': 'Polia do Virabrequim' },
    'Soportes de Motor':          { en: 'Engine Mounts',          fr: 'Supports moteur',              'pt-BR': 'Coxins de Motor' },
    'Solenoide VVT':              { en: 'VVT Solenoid',           fr: 'Solénoïde VVT',                'pt-BR': 'Solenoide VVT' },
    'Aspas / Ventaviolas':        { en: 'Fan Blades',             fr: 'Pales de ventilateur',         'pt-BR': 'Pás do Ventilador' },
    'Bomba Agua':                 { en: 'Water Pump',             fr: "Pompe à eau",                  'pt-BR': "Bomba d'Água" },
    'Carcasas de Termostato':     { en: 'Thermostat Housing',     fr: 'Boîtier de thermostat',        'pt-BR': 'Carcaça do Termostato' },
    'Depósitos':                  { en: 'Reservoirs',             fr: 'Réservoirs',                   'pt-BR': 'Reservatórios' },
    'Enfocadores':                { en: 'Shrouds',                fr: 'Carénages',                    'pt-BR': 'Defletores' },
    'Fan Clutch':                 { en: 'Fan Clutch',             fr: 'Embrayage de ventilateur',     'pt-BR': 'Embreagem do Ventilador' },
    'Motoventiladores':           { en: 'Electric Fans',          fr: 'Motoventilateurs',             'pt-BR': 'Motoventiladores' },
    'Radiadores':                 { en: 'Radiators',              fr: 'Radiateurs',                   'pt-BR': 'Radiadores' },
    'Sensor Temperatura':         { en: 'Temperature Sensor',     fr: 'Capteur de température',       'pt-BR': 'Sensor de Temperatura' },
    'Tapas':                      { en: 'Caps / Covers',          fr: 'Bouchons / Couvercles',        'pt-BR': 'Tampas' },
    'Bomba Gasolina':             { en: 'Fuel Pump',              fr: 'Pompe à carburant',            'pt-BR': 'Bomba de Combustível' },
    'Cuerpos de Aceleración':     { en: 'Throttle Bodies',        fr: 'Corps de papillon',            'pt-BR': 'Corpos de Aceleração' },
    'Válvula IAC':                { en: 'IAC Valve',              fr: 'Valve IAC',                    'pt-BR': 'Válvula IAC' },
    'Sensor Presión Combustible': { en: 'Fuel Pressure Sensor',   fr: 'Capteur pression carburant',   'pt-BR': 'Sensor de Pressão de Comb.' },
    'Válvula EGR':                { en: 'EGR Valve',              fr: 'Valve EGR',                    'pt-BR': 'Válvula EGR' },
    'Sensor MAF':                 { en: 'MAF Sensor',             fr: 'Capteur MAF',                  'pt-BR': 'Sensor MAF' },
    'Sensor MAP':                 { en: 'MAP Sensor',             fr: 'Capteur MAP',                  'pt-BR': 'Sensor MAP' },
    'Sensor Oxígeno':             { en: 'Oxygen Sensor',          fr: 'Sonde lambda',                 'pt-BR': 'Sensor de Oxigênio' },
    'Válvula PCV':                { en: 'PCV Valve',              fr: 'Valve PCV',                    'pt-BR': 'Válvula PCV' },
    'Bobinas':                    { en: 'Ignition Coils',         fr: "Bobines d'allumage",           'pt-BR': 'Bobinas de Ignição' },
    'Sensor CKP':                 { en: 'CKP Sensor',             fr: 'Capteur CKP',                  'pt-BR': 'Sensor CKP' },
    'Sensor CMP':                 { en: 'CMP Sensor',             fr: 'Capteur CMP',                  'pt-BR': 'Sensor CMP' },
    'Actuador Compuerta':         { en: 'Door Actuator',          fr: 'Actionneur de porte',          'pt-BR': 'Atuador de Porta' },
    'Sensor Presión Aceite':      { en: 'Oil Pressure Sensor',    fr: "Capteur pression d'huile",     'pt-BR': 'Sensor de Pressão de Óleo' },
    'Sensor de Reversa':          { en: 'Reverse Sensor',         fr: 'Capteur de marche arrière',    'pt-BR': 'Sensor de Ré' },
    'Sensor de Velocidad':        { en: 'Speed Sensor',           fr: 'Capteur de vitesse',           'pt-BR': 'Sensor de Velocidade' },
    'Sensor Velocímetro':         { en: 'Speedometer Sensor',     fr: 'Capteur vitesse',              'pt-BR': 'Sensor do Velocímetro' },
    'Switch de Ventana':          { en: 'Window Switch',          fr: 'Interrupteur de vitre',        'pt-BR': 'Interruptor de Vidro' },
    'Switch Ignición':            { en: 'Ignition Switch',        fr: "Contacteur d'allumage",        'pt-BR': 'Chave de Ignição' },
    'Switch Limpiaparabrisas':    { en: 'Wiper Switch',           fr: 'Interrupteur essuie-glace',    'pt-BR': 'Interruptor do Limpador' },
    'Switch Luces':               { en: 'Light Switch',           fr: "Interrupteur d'éclairage",     'pt-BR': 'Interruptor de Luzes' },
    'Sensor TPS':                 { en: 'TPS Sensor',             fr: 'Capteur TPS',                  'pt-BR': 'Sensor TPS' },
    'Sensor ABS':                 { en: 'ABS Sensor',             fr: 'Capteur ABS',                  'pt-BR': 'Sensor ABS' },
    'Bocines':                    { en: 'Wheel Hubs',             fr: 'Moyeux',                       'pt-BR': 'Cubos de Roda' },
    'Rodamientos':                { en: 'Bearings',               fr: 'Roulements',                   'pt-BR': 'Rolamentos' },
    'Soportes de Amortiguador':   { en: 'Shock Absorber Mounts',  fr: "Supports d'amortisseur",       'pt-BR': 'Suportes de Amortecedor' },
    'Bomba Hidráulico':           { en: 'Power Steering Pump',    fr: 'Pompe de direction',           'pt-BR': 'Bomba Hidráulica' },
    'Caja Dirección':             { en: 'Steering Gear',          fr: 'Boîtier de direction',         'pt-BR': 'Caixa de Direção' },
    'Eje Dirección':              { en: 'Steering Shaft',         fr: 'Colonne de direction',         'pt-BR': 'Eixo de Direção' },
    'Pera Hidráulica':            { en: 'Hydraulic Cylinder',     fr: 'Vérin hydraulique',            'pt-BR': 'Cilindro Hidráulico' },
    'Poleas':                     { en: 'Pulleys',                fr: 'Poulies',                      'pt-BR': 'Polias' },
    'Tensores de Correa':         { en: 'Belt Tensioners',        fr: 'Tendeurs de courroie',         'pt-BR': 'Tensores de Correia' },
    'Bomba Clutch':               { en: 'Clutch Master Cylinder', fr: "Pompe d'embrayage",            'pt-BR': 'Bomba de Embreagem' },
    'Condensadores':              { en: 'Condensers',             fr: 'Condenseurs',                  'pt-BR': 'Condensadores' },
  };

  function getI18n() {
    const locale = (window.Shopify && window.Shopify.locale) || 'es';
    return ASM_I18N[locale] || ASM_I18N.es;
  }

  function getCatLabel(key) {
    const locale = (window.Shopify && window.Shopify.locale) || 'es';
    return (CATEGORY_LABELS[key] && CATEGORY_LABELS[key][locale]) || key;
  }

  function getSubLabel(handle) {
    const locale = (window.Shopify && window.Shopify.locale) || 'es';
    return (SUB_LABELS[handle] && SUB_LABELS[handle][locale]) || handle;
  }

  function updateCounter(note, make, model, year, engine) {
    if (!note) return;
    const i18n = getI18n();
    const defaultCount = note.dataset.count || '1.062';

    if (!make) {
      note.innerHTML = i18n.defaultNote(defaultCount);
      return;
    }

    note.innerHTML = `<span class="asm-counter--loading">${i18n.loading}</span>`;

    clearTimeout(countDebounce);
    countDebounce = setTimeout(async () => {
      const count = await fetchProductCount(make, model, year, engine);
      const isMobile = window.matchMedia('(max-width: 600px)').matches;

      if (count === null) {
        note.innerHTML = i18n.defaultNote(defaultCount);
      } else if (count === 0) {
        note.innerHTML = `<span class="asm-counter--zero">${i18n.zero}</span>`;
      } else {
        const vehicle = [make, model, year].filter(Boolean).join(' ');
        if (isMobile) {
          note.innerHTML = i18n.found(count);
        } else {
          note.innerHTML = i18n.foundFor(count, vehicle);
        }
      }
    }, 400);
  }

  /* ════════════════════════════════════════════════════════════
     SINCRONIZAR BOTÓN
     ════════════════════════════════════════════════════════════ */

  function syncBtn(btn, note) {
    if (!btn) return;
    const ok = STATE.mode === 'vehicle'
      ? (!!STATE.make || !!STATE.subcategory)
      : !!STATE.reference.trim();
    btn.disabled = !ok;
    btn.classList.toggle('asm-btn--ready', !!(STATE.make && STATE.model));

    const lbl = btn.querySelector('.asm-btn__label');
    if (lbl) {
      const i18n = getI18n();
      if (STATE.make) {
        const parts = [STATE.make, STATE.model, STATE.year].filter(Boolean);
        lbl.textContent = parts.length > 1 ? i18n.searchLabel(parts.join(' ')) : i18n.searchBtn;
      } else {
        lbl.textContent = i18n.searchBtn;
      }
    }

    // Actualizar contador
    if (note && STATE.mode === 'vehicle') {
      updateCounter(note, STATE.make, STATE.model, STATE.year, STATE.engine);
    }
  }

  function syncTrigger(trigger) {
    if (!trigger) return;
    const ind = $('.asm-trigger__vehicle', trigger);
    if (!ind) return;
    if (STATE.make) {
      ind.textContent = [STATE.make, STATE.model].filter(Boolean).join(' ');
      trigger.classList.add('has-vehicle');
    } else {
      trigger.classList.remove('has-vehicle');
    }
  }

  /* ════════════════════════════════════════════════════════════
     RESTAURAR ESTADO EN UN FORMULARIO
     ════════════════════════════════════════════════════════════ */

  function restoreForm(ctx, btns, note) {
    const makeEl   = $('[data-asm="make"]',   ctx);
    const modelEl  = $('[data-asm="model"]',  ctx);
    const yearEl   = $('[data-asm="year"]',   ctx);
    const engineEl = $('[data-asm="engine"]', ctx);

    if (!makeEl) return;

    const makes = Object.keys(VEHICLES).sort();
    fillSelect(makeEl, makes, getI18n().placeholderMake);

    if (STATE.make && VEHICLES[STATE.make]) {
      makeEl.value = STATE.make;
      makeEl.closest('.asm-field')?.classList.add('asm-field--filled');

      const models = Object.keys(VEHICLES[STATE.make]).sort();
      fillSelect(modelEl, models, getI18n().placeholderModel);

      if (STATE.model) {
        modelEl.value = STATE.model;
        modelEl.closest('.asm-field')?.classList.add('asm-field--filled');

        const range = VEHICLES[STATE.make][STATE.model];
        if (range) {
          fillSelect(yearEl, yearRange(range[0], range[1]), getI18n().placeholderYear);
          if (STATE.year) {
            yearEl.value = STATE.year;
            yearEl.closest('.asm-field')?.classList.add('asm-field--filled');
            if (engineEl) {
              engineEl.disabled = false;
              // fillEngines restaura STATE.engine cuando las opciones cargan
              fillEngines(engineEl);
            }
          }
        }
      }
    }

    btns.forEach(b => syncBtn(b, note));

    // Mostrar banner de vehículo guardado si aplica
    showSavedVehicleBanner(ctx);
  }

  /* ════════════════════════════════════════════════════════════
     MEJORA 6 — BANNER DE VEHÍCULO GUARDADO
     ════════════════════════════════════════════════════════════ */

  function showSavedVehicleBanner(ctx) {
    const banner = $('[data-asm="saved-banner"]', ctx);
    if (!banner) return;

    try {
      const saved = JSON.parse(localStorage.getItem(SK_LOCAL) || 'null');
      if (saved?.make) {
        const vehicle = [saved.make, saved.model].filter(Boolean).join(' ');
        const label   = banner.querySelector('[data-asm="saved-label"]');
        if (label) label.textContent = getI18n().savedVehicle(vehicle);
        banner.style.display = 'flex';
      } else {
        banner.style.display = 'none';
      }
    } catch (_) {
      banner.style.display = 'none';
    }
  }

  /* ════════════════════════════════════════════════════════════
     INICIALIZAR FORMULARIO
     ════════════════════════════════════════════════════════════ */

  function initForm(ctx) {
    const makeEl   = $('[data-asm="make"]',   ctx);
    const modelEl  = $('[data-asm="model"]',  ctx);
    const yearEl   = $('[data-asm="year"]',   ctx);
    const engineEl = $('[data-asm="engine"]', ctx);
    const refEl    = $('[data-asm="ref"]',    ctx);
    const btn      = $('[data-asm="btn"]',    ctx);
    const note     = $('[data-asm="note"]',   ctx);
    const tabs     = $$('[data-asm-tab]',     ctx);
    const clearBtn = $('[data-asm="clear"]',  ctx);

    if (!makeEl) return;

    const btns = btn ? [btn] : [];

    // Poblar marcas
    const makes = Object.keys(VEHICLES).sort();
    fillSelect(makeEl, makes, getI18n().placeholderMake);
    makeEl.disabled = false;

    restoreForm(ctx, btns, note);

    // ── Evento: Marca ─────────────────────────────────────────
    makeEl.addEventListener('change', () => {
      const make = makeEl.value;
      STATE.make = make || null;
      STATE.model = STATE.year = STATE.engine = null;
      makeEl.closest('.asm-field')?.classList.toggle('asm-field--filled', !!make);

      if (make && VEHICLES[make]) {
        fillSelect(modelEl, Object.keys(VEHICLES[make]).sort(), getI18n().placeholderModel);
      } else {
        clearSelect(modelEl, getI18n().placeholderModel);
      }
      clearSelect(yearEl, getI18n().placeholderYear);
      if (engineEl) clearSelect(engineEl, getI18n().placeholderEngine);

      btns.forEach(b => syncBtn(b, note));
      saveState();
    });

    // ── Evento: Modelo ────────────────────────────────────────
    if (modelEl) {
      modelEl.addEventListener('change', () => {
        const model = modelEl.value;
        STATE.model = model || null;
        STATE.year = STATE.engine = null;
        modelEl.closest('.asm-field')?.classList.toggle('asm-field--filled', !!model);

        if (model && VEHICLES[STATE.make]?.[model]) {
          const [s, e] = VEHICLES[STATE.make][model];
          fillSelect(yearEl, yearRange(s, e), getI18n().placeholderYear);
        } else {
          clearSelect(yearEl, getI18n().placeholderYear);
        }
        if (engineEl) clearSelect(engineEl, getI18n().placeholderEngine);

        btns.forEach(b => syncBtn(b, note));
        saveState();
      });
    }

    // ── Evento: Año ───────────────────────────────────────────
    if (yearEl) {
      yearEl.addEventListener('change', () => {
        const year = yearEl.value;
        STATE.year = year || null;
        STATE.engine = null;
        yearEl.closest('.asm-field')?.classList.toggle('asm-field--filled', !!year);

        if (engineEl) {
          if (year) { engineEl.disabled = false; shimmer(engineEl); fillEngines(engineEl); }
          else clearSelect(engineEl, getI18n().placeholderEngine);
        }
        btns.forEach(b => syncBtn(b, note));
        saveState();
      });
    }

    // ── Evento: Cilindraje ────────────────────────────────────
    if (engineEl) {
      engineEl.addEventListener('change', () => {
        STATE.engine = engineEl.value || null;
        engineEl.closest('.asm-field')?.classList.toggle('asm-field--filled', !!engineEl.value);
        btns.forEach(b => syncBtn(b, note));
        saveState();
      });
    }

    // ── Categoría + Parte ─────────────────────────────────────
    const catEl  = $('[data-asm="category"]',    ctx);
    const partEl = $('[data-asm="subcategory"]', ctx);

    function resetSelect(sel, placeholder) {
      while (sel.options.length) sel.remove(0);
      sel.add(new Option(placeholder, ''));
      sel.disabled = true;
      sel.closest('.asm-field')?.classList.remove('asm-field--filled');
    }

    function fillParts(sel, items) {
      while (sel.options.length) sel.remove(0);
      sel.add(new Option(getI18n().selectPart, ''));
      items.forEach(item => sel.add(new Option(getSubLabel(item.handle), item.handle)));
      sel.disabled = false;
    }

    if (catEl) {
      while (catEl.options.length) catEl.remove(0);
      catEl.add(new Option(getI18n().optionCategory, ''));
      Object.keys(CATEGORIES).forEach(name => catEl.add(new Option(getCatLabel(name), name)));
      catEl.disabled = false;

      if (partEl) resetSelect(partEl, getI18n().optionPart);

      if (STATE.category && CATEGORIES[STATE.category]) {
        catEl.value = STATE.category;
        catEl.closest('.asm-field')?.classList.add('asm-field--filled');
        if (partEl) {
          fillParts(partEl, CATEGORIES[STATE.category]);
          if (STATE.subcategory) {
            partEl.value = STATE.subcategory;
            partEl.closest('.asm-field')?.classList.add('asm-field--filled');
          }
        }
      }

      catEl.addEventListener('change', () => {
        const cat = catEl.value;
        STATE.category    = cat || null;
        STATE.subcategory = null;
        catEl.closest('.asm-field')?.classList.toggle('asm-field--filled', !!cat);

        if (partEl) {
          if (cat && CATEGORIES[cat]) {
            fillParts(partEl, CATEGORIES[cat]);
            shimmer(partEl);
          } else {
            resetSelect(partEl, getI18n().optionPart);
          }
        }

        btns.forEach(b => syncBtn(b, note));
        saveState();
      });
    }

    if (partEl) {
      partEl.addEventListener('change', () => {
        STATE.subcategory = partEl.value || null;
        partEl.closest('.asm-field')?.classList.toggle('asm-field--filled', !!partEl.value);
        btns.forEach(b => syncBtn(b, note));
        saveState();
      });
    }

    // ── Evento: Referencia ────────────────────────────────────
    if (refEl) {
      refEl.addEventListener('input', () => {
        STATE.reference = refEl.value;
        btns.forEach(b => syncBtn(b, note));
      });
    }

    // ── Tabs de modo ──────────────────────────────────────────
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('asm-tab--active'));
        tab.classList.add('asm-tab--active');
        STATE.mode = tab.dataset.asmTab;

        const vPanel = $('[data-asm-mode="vehicle"]',   ctx);
        const rPanel = $('[data-asm-mode="reference"]', ctx);
        vPanel?.classList.toggle('asm-mode--hidden', STATE.mode !== 'vehicle');
        rPanel?.classList.toggle('asm-mode--hidden', STATE.mode !== 'reference');

        btns.forEach(b => syncBtn(b, note));
      });
    });

    // ── Botón limpiar vehículo guardado ───────────────────────
    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        clearSavedVehicle();
        // Resetear todos los selects
        clearSelect(makeEl, getI18n().placeholderMake);
        makeEl.disabled = false;
        fillSelect(makeEl, Object.keys(VEHICLES).sort(), getI18n().placeholderMake);
        clearSelect(modelEl,  getI18n().placeholderModel);
        clearSelect(yearEl,   getI18n().placeholderYear);
        if (engineEl) clearSelect(engineEl, getI18n().placeholderEngine);
        btns.forEach(b => syncBtn(b, note));
        const banner = $('[data-asm="saved-banner"]', ctx);
        if (banner) banner.style.display = 'none';
      });
    }

    // ── Botón buscar ──────────────────────────────────────────
    if (btn) {
      btn.addEventListener('click', () => {
        const url = buildURL();
        if (url) { saveState(); window.location.href = url; }
      });
    }
  }

  /* ════════════════════════════════════════════════════════════
     PANEL DEL HEADER
     ════════════════════════════════════════════════════════════ */

  // Cierra cualquier details-modal de búsqueda que esté abierto (pueden ser 2 en el header)
  function _closeSearchModal() {
    document.querySelectorAll('details-modal').forEach(modal => {
      if (modal.isOpen?.()) modal.close(false);
    });
  }

  // Cierra el hamburger usando la API nativa de Dawn sin .click() (evita bubbling a onBodyClick).
  // Quitamos open en el mismo tick que closeMenuDrawer quita menu-opening: el navegador
  // batchea ambas mutaciones y nunca renderiza el estado intermedio que causa el flash del ícono X.
  function _closeHamburger() {
    const hw = document.querySelector('header-drawer');
    if (!hw) return;
    const details = hw.querySelector('details');
    const summary = details?.querySelector('summary');
    if (!details?.hasAttribute('open')) return;
    summary?.setAttribute('aria-expanded', 'false');
    hw.closeMenuDrawer({ type: 'asm-close' }, summary);
    details.removeAttribute('open');
  }

  function initPanel() {
    const trigger  = $('.asm-trigger');
    const panel    = $('#asm-panel');
    const overlay  = $('#asm-overlay');
    const closeBtn = $('.asm-panel__close', panel);

    if (!trigger || !panel) return;

    const _focusables = panel.querySelectorAll('button, select, input, a[href]');
    function _setTabIndex(enabled) {
      _focusables.forEach(el => enabled ? el.removeAttribute('tabindex') : el.setAttribute('tabindex', '-1'));
    }
    _setTabIndex(false);

    function open() {
      // Cerrar hamburger y buscador nativo si están abiertos
      _closeHamburger();
      _closeSearchModal();

      panel.classList.add('asm-panel--open');
      overlay?.classList.add('asm-overlay--visible');
      panel.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      _setTabIndex(true);
    }
    function close() {
      panel.classList.remove('asm-panel--open');
      overlay?.classList.remove('asm-overlay--visible');
      panel.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      _setTabIndex(false);
    }

    trigger.addEventListener('click', () =>
      panel.classList.contains('asm-panel--open') ? close() : open()
    );
    closeBtn?.addEventListener('click', close);
    overlay?.addEventListener('click', close);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

    // Cerrar al hacer click fuera del panel o del trigger (independiente del z-index)
    document.addEventListener('click', e => {
      if (!panel.classList.contains('asm-panel--open')) return;
      if (panel.contains(e.target) || trigger.contains(e.target)) return;
      close();
    });

    // Exclusión mutua: hamburger, buscador nativo y panel ASM nunca abiertos al mismo tiempo
    document.addEventListener('toggle', e => {
      if (!e.target.open) return;

      if (e.target.id === 'Details-menu-drawer-container') {
        close();
        _closeSearchModal();
      } else if (e.target.closest('details-modal')) {
        close();
        _closeHamburger();
      }
    }, true);

    initForm(panel);
    syncTrigger(trigger);
  }

  /* ════════════════════════════════════════════════════════════
     MEJORA 1 — FALLBACK INTELIGENTE EN PÁGINA DE RESULTADOS
     Detecta 0 resultados y reintenta sin filtro de año
     ════════════════════════════════════════════════════════════ */

  function initFallback() {
    // FIX 11: Solo en página de colección Y solo si hay filtros de vehículo
    if (!window.location.pathname.includes('/collections/')) return;

    const params  = new URLSearchParams(window.location.search);
    const brand   = params.get('filter.p.m.vehicle.brand');
    const model   = params.get('filter.p.m.vehicle.model');
    const yearLte = params.get('filter.p.m.vehicle.year_from.lte');

    // FIX 11: Si NO hay filtros de vehículo, no hacer nada (no es búsqueda nuestra)
    if (!brand) return;

    // Esperar a que la página cargue y verificar si hay 0 resultados
    function checkResults() {
      const countEl = document.querySelector('.product-count, [data-product-count]');
      const emptyEl = document.querySelector('.template-collection--empty, .collection-empty');
      const bodyText = document.body.innerText;

      const isZero =
        emptyEl !== null ||
        /0\s*(?:productos|products)/i.test(bodyText) ||
        /no se encontró ningún producto|no products found/i.test(bodyText) ||
        (countEl && parseInt(countEl.textContent) === 0);

      // FIX 8: Mostrar banner aunque NO haya año (caso Renault Clio sin año)
      if (isZero) {
        showFallbackBanner(brand, model, yearLte);
      }
    }

    setTimeout(checkResults, 800);
  }

  function showFallbackBanner(brand, model, year) {
    if ($('#asm-fallback-banner')) return;

    const vehicle = [brand, model, year].filter(Boolean).join(' ');

    // FIX 8: Generar el banner según el caso
    let title, description, primaryAction;

    if (year) {
      // Caso 1: tiene año → sugiere quitar el año
      const urlWithoutYear = buildURL(brand, model, null, null);
      title = `No encontramos repuestos específicos para ${vehicle}`;
      description = 'Es posible que tengamos piezas compatibles sin restricción de año.';
      primaryAction = urlWithoutYear ? `
        <a href="${urlWithoutYear}" class="asm-fallback-btn asm-fallback-btn--primary">
          Ver todos los ${[brand, model].filter(Boolean).join(' ')} →
        </a>` : '';
    } else if (model) {
      // Caso 2: sin año pero con modelo → sugiere ver toda la marca
      const urlOnlyBrand = buildURL(brand, null, null, null);
      title = `No tenemos repuestos para ${brand} ${model} en este momento`;
      description = `Estamos ampliando el catálogo. Mientras tanto, puedes ver todos los repuestos de ${brand} disponibles.`;
      primaryAction = urlOnlyBrand ? `
        <a href="${urlOnlyBrand}" class="asm-fallback-btn asm-fallback-btn--primary">
          Ver todos los ${brand} →
        </a>` : '';
    } else {
      // Caso 3: solo marca, sin productos
      title = `Aún no tenemos repuestos de ${brand} en el catálogo`;
      description = 'Estamos trabajando para incorporar más marcas. Mientras tanto, explora nuestro catálogo completo.';
      primaryAction = '';
    }

    const banner = document.createElement('div');
    banner.id = 'asm-fallback-banner';
    banner.innerHTML = `
      <div class="asm-fallback-banner">
        <div class="asm-fallback-banner__inner">
          <span class="asm-fallback-banner__icon">🔍</span>
          <div class="asm-fallback-banner__text">
            <strong>${title}</strong>
            <span>${description}</span>
          </div>
          <div class="asm-fallback-banner__actions">
            ${primaryAction}
            <a href="/collections/all" class="asm-fallback-btn asm-fallback-btn--secondary">
              Ver catálogo completo
            </a>
          </div>
        </div>
      </div>
    `;

    const productGrid = document.querySelector('.template-collection, .collection, main');
    if (productGrid) {
      productGrid.insertBefore(banner, productGrid.firstChild);
    }
  }

  /* ════════════════════════════════════════════════════════════
     BARRA DE RESULTADOS ACTIVOS
     ════════════════════════════════════════════════════════════ */

  function initResultsBar() {
    const bar = $('.asm-results-bar');
    if (!bar) return;

    const params  = new URLSearchParams(window.location.search);
    const brand   = params.get('filter.p.m.vehicle.brand');
    const model   = params.get('filter.p.m.vehicle.model');
    const yearLte = params.get('filter.p.m.vehicle.year_from.lte');
    const engine  = params.get('filter.p.m.vehicle.engine');

    if (!brand && !model && !yearLte && !engine) {
      bar.classList.add('asm-results-bar--hidden');
      return;
    }

    bar.classList.remove('asm-results-bar--hidden');

    const chips  = $('.asm-results-bar__chips', bar);
    const modify = $('.asm-results-bar__modify', bar);

    const filters = [
      { key: 'filter.p.m.vehicle.brand',       label: `🚗 ${brand}`,    val: brand   },
      { key: 'filter.p.m.vehicle.model',        label: model,             val: model   },
      { key: 'filter.p.m.vehicle.year_from.lte',label: `📅 ${yearLte}`,  val: yearLte },
      { key: 'filter.p.m.vehicle.engine',       label: `⚙️ ${engine}`,    val: engine  },
    ].filter(f => f.val);

    filters.forEach(f => {
      if (!chips) return;
      const chip = document.createElement('span');
      chip.className = 'asm-chip';
      chip.innerHTML = `${f.label}
        <button class="asm-chip__remove" data-key="${f.key}" title="Quitar">×</button>`;
      chips.appendChild(chip);
    });

    chips?.addEventListener('click', e => {
      const btn = e.target.closest('.asm-chip__remove');
      if (!btn) return;
      const keyToRemove = btn.dataset.key;
      const newParams = new URLSearchParams(window.location.search);
      newParams.delete(keyToRemove);
      if (keyToRemove === 'filter.p.m.vehicle.year_from.lte') {
        newParams.delete('filter.p.m.vehicle.year_to.gte');
      }
      // FIX 2: Sincronizar localStorage cuando el usuario quita chips
      // Si se quita marca o modelo, limpiamos el vehículo guardado
      try {
        const saved = JSON.parse(localStorage.getItem(SK_LOCAL) || 'null');
        if (saved) {
          if (keyToRemove === 'filter.p.m.vehicle.brand') {
            // Quitar marca → limpiar todo
            localStorage.removeItem(SK_LOCAL);
            sessionStorage.removeItem(SK_SESSION);
          } else if (keyToRemove === 'filter.p.m.vehicle.model' && saved.model) {
            // Quitar modelo → mantener solo marca
            localStorage.setItem(SK_LOCAL, JSON.stringify({ make: saved.make, model: null }));
            sessionStorage.removeItem(SK_SESSION);
          }
        }
      } catch(_) {}
      window.location.search = newParams.toString();
    });

    modify?.addEventListener('click', () => {
      const panel = $('#asm-panel');
      const overlay = $('#asm-overlay');
      if (panel) {
        panel.classList.add('asm-panel--open');
        overlay?.classList.add('asm-overlay--visible');
      }
    });
  }

  /* ════════════════════════════════════════════════════════════
     INICIALIZACIÓN
     ════════════════════════════════════════════════════════════ */

  function init() {
    loadState();

    // Formulario homepage
    const homeForm = $('#asm-home-form');
    if (homeForm) initForm(homeForm);

    // Panel header
    initPanel();

    // Barra de resultados
    initResultsBar();

    // Mejora 1: Fallback en página de colección
    initFallback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
